import Header from "../components/Header";
import Templates from "../components/Templates";
import "../styles/home.css";
import bgImg from "../images/bg.png";
import bgMobile from "../images/bg-mobile.png";

const Home = () => {
  return (
    <div className="home">
      <Header />
      <div className="banner px-12 flex flex-col">
        <h2>Meme Generator</h2>
        <p>Make memes from your pictures in just a few clicks</p>
        <div className="steps mt-6 space-y-4">
          <div className="steps-item">
            <span className="step-item">Step 1</span>
            <span className="step-item-text">Click to Select Template</span>
          </div>
          <div>
            <span className="step-item">Step 2</span>
            <span className="step-item-text">Click to Select Photo</span>
          </div>
          <div>
            <span className="step-item">Step 3</span>
            <span className="step-item-text">Download Meme</span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end mt-12 h-full overflow-hidden">
        <img src={bgImg} alt="bgImg" className="relative -right-20 bgDesktop" />
        <img src={bgMobile} alt="bgImg" className="bgMobile" />
      </div>
      <div className="bg-white h-16 -mt-10"></div>
      <div className="stepsII space-y-4">
        <div className="steps-item">
          <span className="step-item">Step 1</span>
          <span className="step-item-text">Click to Select Template</span>
        </div>
        <div>
          <span className="step-item">Step 2</span>
          <span className="step-item-text">Click to Select Photo</span>
        </div>
        <div>
          <span className="step-item">Step 3</span>
          <span className="step-item-text">Download Meme</span>
        </div>
      </div>
      <div className="templates-section">
        <Templates />
      </div>
    </div>
  );
};

export default Home;
